// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 注册 vuex
import Vuex from 'vuex';
Vue.use(Vuex);
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
var _uid = false;
if (localStorage.uid) {
  console.log("是不是每个页面都进来呢"+localStorage.uid)
	_uid = localStorage.uid;
}
var store = new Vuex.Store({
	state: { // 调用：this.$store.state.***
  // 使用 sessionStorage 代替 localStorage
		// uid: _uid,
    //xhx 202506041934 添加为了定时清空uid,原来是上面的
     uid: sessionStorage.getItem('uid') || null,
		count: 0,
		bottom_nav: 1
	}, // 相当于组件的 data
	mutations: { // 调用：this.$store.commit('方法的名称', '按需传递唯一的参数')
		addUserId(state, data) {
			state.uid = data.uid;
			localStorage.uid = state.uid;
      localStorage.userToken = data.token;
		},
		addNum(state, num) {
			state.count = num;
		},
		bottom_nav(state, bottom_nav) {
			state.bottom_nav = bottom_nav;
		},
    //xhx 202506041934 添加为了定时清空uid,下面这几个方法新增的
     // 新增：重置活动时间
      // resetInactivityTimer(state) {
      //   // 清除旧计时器
      //   if (state.inactivityTimer) clearTimeout(state.inactivityTimer);

      //   // 设置新计时器（15分钟无操作自动登出）
      //   state.inactivityTimer = setTimeout(() => {
      //     console.log("进入清空记录")
      //     state.uid = null;
      //     localStorage.removeItem('uid');
      //     // 可以添加跳转到登录页的逻辑
      //   }, 120 * 60 * 1000); // 120分钟,这里设置120分钟后再登录
      // },

      // 新增：记录用户活动
      // recordUserActivity(state) {
      //   console.log("用户有新活动")
      //   state.lastActivityTime = Date.now();
      //   this.commit('resetInactivityTimer');
      // }

	},
	// 调用：this.$store.getters.***
	getters: {
		get_user_id(state) {
			return state.uid;
		},
		get_user_num(state) {
			return state.count;
		},
		get_bottom_nav(state) {
			return state.bottom_nav;
		},
	},

});


import 'vant/lib/index.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入rem单位使用
import "./lib/rem.js";
Vue.use(ElementUI);
Vue.config.productionTip = false;
// vant 三连地区
import { Picker } from 'vant';
// 样式坑不能加后缀
import "vant/lib/picker/style";
Vue.use(Picker);

//vant
import { Dialog } from 'vant';
// 全局注册
Vue.use(Dialog);
import { Switch } from 'vant';
Vue.use(Switch);
import { Toast } from 'vant';
Vue.use(Toast);
import { Collapse, CollapseItem } from 'vant';
Vue.use(Collapse).use(CollapseItem);

import { Loading } from 'vant';
Vue.use(Loading);



// // 安装 图片预览插件
// import VuePreview from 'vue-preview';
// Vue.use(VuePreview);

// 1.3 导入自己的 router.js 路由模块
// import router from './router.js';

// 导入 App 根组件
import app from './App.vue';
import { Stepper } from 'vant';
import 'vant/lib/button/style';
Vue.use(Stepper);
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
	router,
	store,
  components: { App },
  template: '<App/>',
  created() {
    //xhx 202506041850 增加
      // 添加全局路由守卫
      // this.$router.beforeEach((to, from, next) => {
      //   // 检查是否需要登录
      //   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

      //   // 从 Vuex 获取用户 ID
      //   const isLoggedIn = this.$store.state.uid;

      //   // 如果需要登录但未登录，则跳转到登录页
      //   if (requiresAuth && !isLoggedIn) {
      //      console.log("123123用户未登录，跳转到登录页面");
      //     next('/'); // 替换为你的登录路由路径
      //   } else {
      //     next();
      //   }
      // });
        //xhx 202506041934 添加为了定时清空uid,下面新增的监测
      //初始加载时检查登录状态
      if (!this.$store.state.uid) {

        if (this.$route.path !== '/' && this.$route.path !== '/GoodsAdduser') {
          console.log("用户未登录，跳转到登录页面123123",this.$route.path);
          this.$router.push('/');
        }
      }
    }
})



// WEBPACK FOOTER //
// ./src/main.js